import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_humanities_architecture_gray/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-0a274ae035.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-6fff54e3cf.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-c59833e7ee.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-5368ef19cc.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-cc13e2de77.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-c7a744c5e0.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-f1a9a29f8d.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-e919fec146.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-a95aed715d.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-deaec91b1e.png'; };
